import React, { useState } from 'react';


const CopyButton = ({ title, text, url }) => {
    const [buttonText, setButtonText] = useState('Copy URL');

    const handleCopy = async () => {
        try {
            await navigator.clipboard.writeText(url);
            setButtonText('Copied');
        } catch (error) {
            console.error('Error copying URL to clipboard:', error);
        }
    };

    return (
        <button className="button" onClick={handleCopy}>
            {buttonText}
        </button>
    );
};

export default CopyButton;